import * as Models from "../ts/rlAdmin.models";
import * as Utils from "../ts/rlAdmin.utils";
import * as Consts from "../ts/rlAdmin.consts";
import * as angular from "angular";

import { AdminService } from "../services/admin-service";
import { EntityService } from "../services/entity-service";
import { EntityConfigService } from "../services/entity-config-service";
import { ContactService } from "../services/contact-service";
import { ContractSharedDataService } from "../services/contract-shared-data-service";
import { NotifyService } from "../services/notify-service";
import { EventService } from "../services/event-service";
import { AclService } from "../services/acl-service";
import { PartyGroupService } from "../services/party-group-service";

export function RLContacts() {

	var directive: ng.IDirective = {
		restrict: "EA",
		template: require("/assets/app/templates/contacts.html"),
		controllerAs: "cVM",
		controller: RLContactsController,
		bindToController: true,
		scope: {
			entityID: "=entityId",
			locked: "=",
			snapshotEdit: "=",
			isEditMode: "=",
			successUrl: "=?",
			cancelUrl: "=?",
			isAssociation: "=?",
			associationParentEntityID: "=?associationParentEntityId",
			viewNewRecord: "=?"
		}
	};

	return directive;
}

export class RLContactsController {
	static $inject = ["$scope", "$window", "$q", "$location", "$interval", "adminService", "entityService", "entityConfigService", "contactService", "contractSharedDataService", "notifyService", "eventService", "aclService", "partyGroupService"];

	entityID: string;
	charTypeID: number;
	templateID: number;
	visibility: number;
	snapshotEdit: boolean;
	isEditMode: string;
	successUrl: string;
	cancelUrl: string;
	isAssociation: string;
	associationParentEntityID: string;
	viewNewRecord: string;

	initialized: boolean;
	loading: boolean;

	allContacts: Models.IContactParty[];
	availableContacts: Models.IContactParty[];
	filteredContacts: Models.IContactParty[];
	editContactModalOpen: boolean;
	editContactCharDataCollection: Models.ICharDataCollection;
	editContactModalTitle: string;
	searchContactModalOpen: boolean;
	searchContactPartyID: number;
	searchContactModalTitle: string;
	updateMode: string;
	createMode: boolean;
	contactTemplates: Models.ICharacteristicTemplate[];
	filteredContactTemplates: Models.ICharacteristicTemplate[];
	createContactCharDataCollection: Models.ICharDataCollection;

	//Party Groups
	allPartyGroups: Models.IPartyGroup[];
	contactGroups: Models.IPartyGroup[];
	noGroupContacts: Models.IContactParty[];
	groupCollapsed: { [groupID: string]: boolean };
	isCollapsed: boolean;

	//Easy Party Entry
	editMode: boolean;
	contractID: string;
	locked: boolean;
	canEdit: boolean;
	canSync: boolean;
	canBulkOverwrite: boolean;
	allNoGroupContacts: Models.IContactParty[];
	allParties: Models.IContactParty[];
	associateContactModalOpen: boolean;
	associateContactModalTitle: string;
	showRequiredOnly: boolean;
	newContact: Models.IContactSearchModel;

	//Progress
	jobTitle: string;
	progressJobID: string;
	public progressModalOpen: boolean;
	progressStatus: string;
	progressComplete: number;
	progressFailed: number;
	progressFailedPercentage: number;
	progressTotal: number;
	progressPercentage: number;
	progressIntervalPromise: ng.IPromise<any>;
	progressOnComplete: () => any;
	hasChildTemplates: boolean;

	canCreate: boolean;

	constructor(private $scope: ng.IScope,
		private $window: ng.IWindowService,
		private $q: ng.IQService,
		private $location: ng.ILocationService,
		public $interval: ng.IIntervalService,
		public adminService: AdminService,
		private entityService: EntityService,
		private entityConfigService: EntityConfigService,
		private contactService: ContactService,
		private sharedData: ContractSharedDataService,
		private notifyService: NotifyService,
		private eventService: EventService,
		private aclService: AclService,
		private partyGroupService: PartyGroupService) {

		this.charTypeID = 0;
		this.visibility = 1;
		this.initialized = false;
		this.filteredContacts = [];
		this.allContacts = [];
		this.availableContacts = [];
		this.editContactModalOpen = false;
		this.editContactCharDataCollection = null;
		this.editContactModalTitle = "";
		this.searchContactModalOpen = false;
		this.searchContactPartyID = -1;
		this.searchContactModalTitle = "";
		this.updateMode = "system";

		this.createMode = false;
		this.contactTemplates = [];
		this.filteredContactTemplates = [];
		this.createContactCharDataCollection = null;

		//Party Groups
		this.allPartyGroups = [];
		this.contactGroups = [];
		this.noGroupContacts = [];
		this.groupCollapsed = {};
		this.isCollapsed = false;

		//Easy Party Entry
		this.editMode = false;
		this.contractID = "";
		this.canEdit = false;
		this.canSync = false;
		this.canBulkOverwrite = false;
		this.allNoGroupContacts = [];
		this.allParties = [];
		this.associateContactModalOpen = false;
		this.showRequiredOnly = true;

		//Progress
		this.progressJobID = "";
		this.progressModalOpen = false;
		this.progressStatus = "";
		this.progressComplete = 0;
		this.progressFailed = 0;
		this.progressTotal = 0;
		this.progressPercentage = 0;
		this.progressFailedPercentage = 0;
		this.progressIntervalPromise = null;
		this.progressOnComplete = null;
		this.hasChildTemplates = false;

		this.canCreate = false;

		$scope.$watch(() => this.editContactModalOpen,
			(newValue: boolean, oldValue: boolean) => {
				if (!newValue && oldValue) {
					this.editContactCharDataCollection = null;
					this.editContactModalTitle = "";
				}
			}, true);

		$scope.$watch(() => this.searchContactModalOpen,
			(newValue: boolean, oldValue: boolean) => {
				if (!newValue && oldValue) {
					this.searchContactModalTitle = "";
					this.searchContactPartyID = -1;
					this.createContactCharDataCollection = null;
					this.createMode = false;
				}
			}
			, true);

		$scope.$watch(() => this.entityID,
			(newValue, oldValue) => {
				if (this.entityID != null) {
					this.Init();
					this.LoadPartyGroups();
				}
			});
	}

	Init() {
		if (this.isEditMode == "1") {
			this.contactService.getContactsForEntity(this.entityID)
				.then((contactResult) => {
					var allVisibleContacts = _.filter(contactResult, (party: Models.IContactParty) => party.party.visibilityIndicator >= 1);

					//If there are no Parties, then just call Cancel to continue to the newly created entity
					if (allVisibleContacts.length == 0) {
						this.Cancel();
					}
				});
		}

		this.charTypeID = Utils.IdBuilder.splitEntityID(this.entityID).charTypeID;

		if (this.isAssociation != null && this.isAssociation == "true" && this.associationParentEntityID != null) {
			this.CopyPartiesAndContactsFromParent(this.associationParentEntityID);
		}

		//Determine if the previous page was a Create, and if so, pop into edit mode
		var promises = [this.RefreshEntityTemplate(), this.RefreshContacts(), this.RefreshTemplates()];
		return this.$q.all(promises)
			.then(() => {
				if (this.isEditMode == "1") {
					this.Edit();
				}

				if (this.charTypeID == Consts.CharTypeIDs.property && this.templateID > 0) {
					this.entityService.getAssociatedTemplatesForTemplate(Consts.CharTypeIDs.property, this.templateID, Consts.CharTypeIDs.property).
						then((result) => {
							if (result.length > 0) {
								this.hasChildTemplates = true;
							}
						});
				}

				//Get ACLs for user
				this.entityService.getEntityRecord(this.entityID)
					.then((result) => {
						var targetACL = Utils.AclUtil.getDataEntityAcl(result.charTypeID, result.templateGroupID, result.templateID);
						this.canCreate = Utils.AclUtil.hasCreateAccess(this.aclService.acls, targetACL);
						this.canEdit = Utils.AclUtil.hasWriteAccess(this.aclService.acls, targetACL);
						if (this.charTypeID === Consts.CharTypeIDs.property && this.templateID > 0) {
							this.canSync = Utils.AclUtil.hasWriteAccess(this.aclService.acls, Consts.Acl.Activities._Site._Mod1.Contacts);
						}
					});

				this.aclService.loadActivityAcls()
					.then((acls) => {
						this.canBulkOverwrite = Utils.AclUtil.hasWriteAccess(acls, Consts.Acl.Activities._Site.BulkContactOverwrite);
					});
			});
	}

	RefreshEntityTemplate(): ng.IPromise<any> {
		return this.entityService.getEntityRecord(this.entityID).then((result) => {
			this.templateID = result.templateID;
		});
	}

	RefreshTemplates(): ng.IPromise<any> {
		this.notifyService.startProgress();
		return this.entityConfigService.getCharacteristicTemplates(Consts.CharTypeIDs.user)
			.then((result) => {
				this.contactTemplates = result;
			})
			.finally(() => {
				this.notifyService.endProgress();
			});
	}

	RefreshContacts(): ng.IPromise<any> {
		this.loading = true;
		this.notifyService.startProgress();
		return this.contactService.getContactsForEntity(this.entityID)
			.then((result) => {
				this.allContacts = _.filter(result, (party: Models.IContactParty) => party.party.visibilityIndicator >= 1);
				this.availableContacts = _.filter(result, (party: Models.IContactParty) => party.party.visibilityIndicator >= 1 && (party.contacts.length == 0 || party.party.multipleIndicator));
				this.filteredContacts = _.filter(result, (party: Models.IContactParty) => party.party.visibilityIndicator >= 1 && party.contacts.length > 0);
				this.noGroupContacts = _.filter(result, (party: Models.IContactParty) => party.party.visibilityIndicator >= 1 && party.contacts.length > 0 && (party.party.partyGroupID == undefined || party.party.partyGroupID < 1));
				this.allParties = result;
				this.allNoGroupContacts = _.filter(result, (party: Models.IContactParty) => party.party.visibilityIndicator >= 1 && (party.party.partyGroupID == undefined || party.party.partyGroupID < 1));
				this.eventService.call(Consts.Events.ContactsRefreshed);
			})
			.finally(() => {
				this.notifyService.endProgress();
				this.loading = false;
			});
	}

	CopyPartiesAndContactsFromParent(parentEntityID) {
		return this.contactService.getContactsForEntity(parentEntityID)
			.then((result) => {

			});
	}

	LoadPartyGroups() {
		this.partyGroupService.getPartyGroupList()
			.then((results) => {
				this.allPartyGroups = _.filter(results, (group: Models.IPartyGroup) => group.visibilityIndicator >= 1);
			})
			.finally(() => {
				this.allPartyGroups = _.sortBy(this.allPartyGroups, (group) => group.sequenceNumber);
				this.ProcessPartyGroups();
			});
	}

	ProcessPartyGroups() {
		_.forEach(this.allPartyGroups, (group) => {
			var partyGroupID = group.groupID;

			this.partyGroupService.getPartyGroupDataCountPerCharAndTemplate(partyGroupID, this.charTypeID, this.templateID)
				.then((result) => {
					if (result.data > 0) {
						this.contactGroups.push(group);
					}
				});

			if (group.expandGroupIndicator == 0) {
				//Collapse the panel
				this.groupCollapsed[partyGroupID.toString()] = true;
			}
		});
	}

	GetGroupContacts(groupID: number) {
		return _.filter(this.filteredContacts, (party: Models.IContactParty) => party.party.partyGroupID == groupID);
	}

	GetAllGroupContacts(groupID: number) {
		var i = 12;

		return _.filter(this.allParties, (party: Models.IContactParty) => party.party.partyGroupID == groupID);
	}

	RefreshValidation(): ng.IPromise<any> {
		return this.eventService.call(Consts.Events.ValidateEntity);
	}

	EditContact(contact: Models.IEntityRelationshipPair) {
		this.editContactCharDataCollection = _.cloneDeep(contact.charDataCollection);
		this.editContactModalTitle = "Edit " + contact.record.title;
		this.editContactModalOpen = true;
	}

	SaveContact(isValid: boolean) {
		if (isValid) {
			var charTypeID = Utils.IdBuilder.splitEntityID(this.entityID).charTypeID;
			var recID = Utils.IdBuilder.splitEntityID(this.entityID).recID;
			var contactID = Utils.IdBuilder.splitEntityID(this.editContactCharDataCollection.entityID).recID;
			var charDatas = this.editContactCharDataCollection.charDatas;
			var updateProfile = !(this.updateMode.toLowerCase() == "contact" && this.snapshotEdit);

			this.notifyService.startProgress();

			this.contactService.updateContactPartyCharacteristics(charTypeID, recID, contactID, charDatas, updateProfile)
				.then(() => {
					this.notifyService.notifySuccess("Contact updated");
					this.RefreshContacts();
				}, () => {
					this.notifyService.notifyError("Error updating contact");
					//return this.$q.reject();
				})
				.then(() => {
					this.editContactModalOpen = false;
					this.RefreshValidation();
				}, angular.noop)
				.finally(() => {
					this.notifyService.endProgress();
				});
		}
	}

	AddContact(party: Models.IParty) {
		this.contactService.getPartyTemplates(this.charTypeID, this.templateID, party.partyID).then((templateResult) => {
			this.aclService.loadDataAcls().then((aclResult) => {
				//filter the list of templates allowed to be created by those that can be added to this party
				this.filteredContactTemplates = _.filter(this.contactTemplates, (t) => {
					return _.any(templateResult, (pt) => {
						var partyTemplate = Utils.IdBuilder.splitTemplateID(pt);
						return partyTemplate.templateID == t.templateID && Utils.AclUtil.hasCreateAccess(aclResult, Utils.AclUtil.getDataEntityAcl(Consts.CharTypeIDs.user, t.templateGroupID, t.templateID));
					})
				});
			});
		})
			.finally(() => {
				this.searchContactModalOpen = true;
				this.searchContactPartyID = party.partyID;
				this.searchContactModalTitle = "Add Contact to " + party.partyName + " Party";
			});
	}

	AssociateContactFromQuickSearch(contact: string) {
		this.AssociateContactToParty(contact, false);
	}

	//Associate to contact to the party
	AssociateContactToParty(contact: string, isNew: boolean) {
		this.notifyService.startProgress();

		var partyID = this.searchContactPartyID;
		var recID = Utils.IdBuilder.splitEntityID(this.entityID).recID;
		var charTypeID = Utils.IdBuilder.splitEntityID(this.entityID).charTypeID;

		var splits = contact.split("|");
		var contactID = _.parseInt(splits[0]);
		var contactName = splits[1];

		//How many contacts do we currently have?  We want to add this new one at the end of the list
		return this.contactService.getContactsForEntityByParty(this.entityID, partyID)
			.then((results) => {

				var sequenceNumber = 0;

				if (results.contacts) {
					sequenceNumber = results.contacts.length;
				}

				return this.contactService.associateContactToEntity(charTypeID, recID, partyID, contactID, sequenceNumber)
					.then((result) => {
						if (result) {
							this.notifyService.notifySuccess("Contact Added");
						} else {
							this.notifyService.notifyError("Error adding contact");
						}
						return this.RefreshContacts();
					})
					.then(() => {
						if (this.searchContactModalOpen) {
							this.searchContactModalOpen = false;
						}
						this.RefreshValidation();
					})
					.finally(() => {
						this.notifyService.endProgress();
					});
			});


	}

	//Add additional associations (parent, child, sibling) to the new contact
	AssociateContactToContact() {
		this.searchContactModalOpen = false;
		this.associateContactModalOpen = true;
		this.associateContactModalTitle = "Optional - ";
	}

	RemoveContact(party: Models.IParty, contact: Models.IEntityRelationshipPair) {
		if (this.$window.confirm("Are you sure?")) {
			this.notifyService.startProgress();

			var recID = Utils.IdBuilder.splitEntityID(this.entityID).recID;
			var charTypeID = Utils.IdBuilder.splitEntityID(this.entityID).charTypeID;

			this.contactService.removeContactFromEntity(charTypeID, recID, party.partyID, contact.record.recordID)
				.then(() => {
					this.notifyService.notifySuccess("Contact Successfully Removed");
					return this.RefreshContacts();
				},
				() => {
					this.notifyService.notifyError("Error removing Contact");
				})
				.then(() => {
					this.RefreshContacts();
					this.RefreshValidation();
				})
				.finally(() => {
					this.notifyService.endProgress();
				});

		} else {
			this.$scope.$broadcast(Consts.Events.NotifyDone);
		}
	}

	OverwriteContacts(contact: Models.IEntityRelationshipPair, partyID: number, partyName: string) {
		if (this.$window.confirm("Are you sure you want to overwrite the contact(s) in " + partyName + " to " + contact.record.title + " for associated records?")) {
			this.notifyService.startProgress();
			var recordID = Utils.IdBuilder.splitEntityID(this.entityID).recID;
			var contactID = contact.record.recordID;
			var charTypeID = contact.relationship.parentCharTypeID;

			this.contactService.overwriteContacts(this.entityID, contactID, partyID)
				.then((result) => {
					var jobID = result.jobID;
					this.jobTitle = result.jobTitle;
					this.ShowProgress(jobID, () => {
					});
				},
				() => {
					this.notifyService.notifyError("Error overwriting party contacts");
				})
				.finally(() => {
					this.notifyService.notifySuccess("Party Contacts Overwritten");
					this.notifyService.endProgress();
				});
		} else {
			this.$scope.$broadcast(Consts.Events.NotifyDone);
		}
	}

	ResyncContact(contact: Models.IEntityRelationshipPair) {
		if (this.$window.confirm("Are you sure you want to resync this contact profile from system values?")) {
			this.notifyService.startProgress();
			var recordID = Utils.IdBuilder.splitEntityID(this.entityID).recID;
			var contactID = contact.record.recordID;
			this.contactService.resyncContact(contact.relationship.parentCharTypeID, recordID, contactID)
				.then(() => {
					this.notifyService.notifySuccess("Contact Profile Resynced");
					this.RefreshContacts();
				},
				() => {
					this.notifyService.notifyError("Error resyncing contact");
				})
				.finally(() => {
					this.notifyService.endProgress();
				});
		} else {
			this.$scope.$broadcast(Consts.Events.NotifyDone);
		}
	}

	NewContact(template: Models.ICharacteristicTemplate, $event: ng.IAngularEvent) {
		$event.preventDefault();
		var divID = Utils.IdBuilder.splitEntityID(this.entityID).divID;
		var charTypeID = Consts.CharTypeIDs.user;
		var templateID = Utils.IdBuilder.buildTemplateID(divID, charTypeID, template.templateID);

		this.notifyService.startProgress();

		this.entityService.getEmptyEntityCharData(templateID)
			.then((result) => {
				this.createContactCharDataCollection = result;
				this.createMode = true;
			})
			.finally(() => {
				this.notifyService.endProgress();
			});
	}

	CreateContact(isValid: boolean, andAssociate: boolean) {
		if (isValid) {
			const charDatas = this.createContactCharDataCollection.charDatas;
			const templateID = this.createContactCharDataCollection.templateMetaData.templateID;

			this.notifyService.startProgress();
			this.contactService.createAssociatedContact(templateID, charDatas)
				.then((result) => {
					this.newContact = undefined;
					if (!result.success) {
						this.notifyService.notifyError("Error creating Contact");
					}
					var newContactEntityID = Utils.IdBuilder.splitEntityID(result.entityID);
					var newContactRecID = newContactEntityID.recID;
					var contact = newContactRecID + "|new";
					var contactName = "";
					if (_.any(this.createContactCharDataCollection.charDatas["first_name"])) {
						var firstNameCharDatas = this.createContactCharDataCollection.charDatas["first_name"];
						var lastNameCharDatas = this.createContactCharDataCollection.charDatas["last_name"];
						if (!_.isEmpty(firstNameCharDatas[0].value)) {
							contactName = firstNameCharDatas[0].value;
						}

						if (!_.isEmpty(lastNameCharDatas[0].value)) {
							contactName = contactName + ' ' + lastNameCharDatas[0].value;
						}
					} else {
						var contactNameCharDatas = this.createContactCharDataCollection.charDatas["entity_title"];
						contactName = contactNameCharDatas[0].value;
					}

					this.newContact = {
						contactID: newContactRecID,
						name: contactName,
						charDataCollection: this.createContactCharDataCollection,
						parentCharTypeID: null,
						sequenceNumber: null
					};
					return this.AssociateContactToParty(contact, true);
				})
				.finally(() => {
					if (andAssociate) {
						this.AssociateContactToContact();
					}
					this.createContactCharDataCollection = undefined;
					this.notifyService.endProgress();
				});
		} else {
			this.notifyService.broadcastDone();
		}
	}

	ToggleOpen(groupID: string) {
		this.groupCollapsed[groupID] = !this.groupCollapsed[groupID];
	}

	CollapseToggle() {
		this.isCollapsed = !this.isCollapsed;

		if (this.isCollapsed) {
			this.groupCollapsed["0"] = true;

			_.forEach(this.contactGroups, (group) => {
				this.groupCollapsed[group.groupID.toString()] = true;
			});
		}
		else {
			this.groupCollapsed = {};
		}
	}

	Edit() {
		this.filteredContacts = _.filter(this.allContacts, (party: Models.IContactParty) => party.party.visibilityIndicator >= 1);
		this.editMode = true;
	}

	Cancel() {
		if (this.isEditMode == "1") {
			if (this.isAssociation == "true" || this.associationParentEntityID != null && this.associationParentEntityID != "-2") {
				var recID = Utils.IdBuilder.splitEntityID(this.associationParentEntityID).recID;
				var successUrl = this.successUrl.replace("-1", recID.toString());

				if (this.viewNewRecord == "1") {
					successUrl = "/go/" + this.entityID;
				}

				if (this.successUrl.indexOf(Consts.Urls.CreateAndAssociateHierarchicalRecords) != -1) {
					successUrl = this.successUrl.replace("-1", Utils.IdBuilder.splitEntityID(this.entityID).recID.toString());
					successUrl += "?parentEntityID=" + this.associationParentEntityID;
					successUrl += "&an=1";
				}


				this.$window.location.assign(successUrl);
			}
			else {
				var recID = Utils.IdBuilder.splitEntityID(this.entityID).recID;
				var successUrl = this.successUrl.replace("-1", recID.toString());

				if (this.viewNewRecord == "1") {
					successUrl = "/go/" + this.entityID;
				}

				this.$window.location.assign(successUrl);
			}
		}
		else {
			this.notifyService.startProgress();
			this.editMode = false;
			this.RefreshContacts();
			this.notifyService.endProgress();
		}
	}

	CancelEditMode() {
		if (this.isAssociation == "true") {
			var recID = Utils.IdBuilder.splitEntityID(this.associationParentEntityID).recID;
			var successUrl = this.successUrl.replace("-1", recID.toString());
			this.$window.location.assign(successUrl);
		}
		else {
			var recID = Utils.IdBuilder.splitEntityID(this.entityID).recID;
			var successUrl = this.successUrl.replace("-1", recID.toString());
			this.$window.location.assign(successUrl);
		}
	}

	Save(isValid: boolean) {

		if (isValid) {
			this.notifyService.startProgress();
			this.entityService.saveCharData(this.sharedData.contract.record.id, this.sharedData.contract.charDataCollection.charDatas)
				.then(() => {
					this.notifyService.notifySuccess("Save Successful");
					return this.RefreshDetails();
				}, this.notifyService.errorResponseHandler)
				.then(() => {
					this.editMode = false;
					this.RefreshValidation();
				})
				.finally(() => {
					this.notifyService.endProgress();
				});

		}
	}

	RefreshDetails() {
		return this.sharedData.RefreshContract(this.contractID)
			.then((result) => {
				this.initialized = true;
			}, () => {
				this.notifyService.notifyError("Contract Not Found");
			});
	}

	//Progress Functions
	ShowProgress(jobID: string, onComplete: () => any) {
		this.ResetProgress();

		this.progressJobID = jobID;
		this.progressOnComplete = onComplete;

		this.notifyService.startProgress();
		this.progressIntervalPromise = this.$interval(() => this.UpdateProgress(), 2000);
		this.UpdateProgress();
		this.progressModalOpen = true;
	}

	UpdateProgress() {
		this.adminService.getJobState(this.progressJobID)
			.then((result) => {
				this.progressComplete = result.completed;
				this.progressFailed = result.failed;
				this.progressStatus = result.status;
				this.progressTotal = result.total;
				this.progressPercentage = (this.progressComplete / this.progressTotal) * 100;
				this.progressFailedPercentage = (this.progressFailed / this.progressTotal) * 100;


				if (result.status == "Done" || result.status == "Failed" || result.status == "Cancelled") {
					this.$interval.cancel(this.progressIntervalPromise);
					if (this.progressOnComplete != null) {
						this.$q.when(this.progressOnComplete())
							.then(() => {
								this.notifyService.endProgress();
							});
					} else {
						this.notifyService.endProgress();
					}
				}
			});
	}

	CancelJob() {
		this.adminService.cancelJob(this.progressJobID)
			.then((res) => {
			});
	}

	ResetProgress() {
		this.progressJobID = "";
		this.progressModalOpen = false;
		this.progressStatus = "";
		this.progressComplete = 0;
		this.progressTotal = 0;
		this.progressPercentage = 0;
		if (this.progressIntervalPromise != null) {
			this.$interval.cancel(this.progressIntervalPromise);
			this.progressIntervalPromise = null;
		}
	}

	SyncAllContactParties() {
		if (this.$window.confirm("Are you sure you want to sync Contact associations in matching Parties down this Catalog hierarchy?")) {
			var recID = Utils.IdBuilder.splitEntityID(this.entityID).recID;
			var request: Models.ISyncMetaDataOrPartiesToHierarchicalRecordsRequest = {
				charTypeID: this.charTypeID,
				recID: recID,
				partyID: -1,
				contactID: -1,
				characteristicIDs: [],
				syncMode: Consts.SyncMode.SyncAllContactParties
			};

			this.notifyService.startProgress();
			this.entityService.syncMetaDataOrPartiesToHierarchicalRecords(request)
				.then((result) => {
					var jobID = result.jobID;
					this.jobTitle = result.jobTitle;
					this.ShowProgress(jobID, () => {
					});
				})
				.finally(() => {
					this.notifyService.endProgress();
				});
		}
	}

	SyncContactParty(recordID: number, partyID: number) {
		if (this.$window.confirm("Are you sure you want to sync Contact associations in matching Party down this Catalog hierarchy?")) {
			var parentRecID = Utils.IdBuilder.splitEntityID(this.entityID).recID;
			var request: Models.ISyncMetaDataOrPartiesToHierarchicalRecordsRequest = {
				charTypeID: this.charTypeID,
				recID: parentRecID,
				partyID: partyID,
				contactID: recordID,
				characteristicIDs: [],
				syncMode: Consts.SyncMode.SyncContactParty
			};

			this.notifyService.startProgress();
			this.entityService.syncMetaDataOrPartiesToHierarchicalRecords(request)
				.then((result) => {
					var jobID = result.jobID;
					this.jobTitle = result.jobTitle;
					this.ShowProgress(jobID, () => {
					});
				})
				.finally(() => {
					this.notifyService.endProgress();
				});
		}
	}
}
